import style from "./style.module.scss";
import FaceBookIcon from "./icons/facebook";
import XIcon from "./icons/x";
import CopyLinkIcon from "./icons/copyLinkIcon";
import { PostType } from "@components/severalbrands/gqlQueries";
import { getUrl, getFormattedDate } from "@components/severalbrands/utils";
import { motion } from "framer-motion";
import { replacePlaceholders } from "@lib/sharedUtils";
import { useState } from "react";

export default function FirstSection({
    post,
    mainUrl,
}: {
    post: PostType;
    mainUrl: string;
}) {
    const category = post?.category?.label ?? post?.category?.name;
    const [showCopySuccessMessage, setShowCopySuccessMessage] = useState(false);
    return (
        <section className={style["bgStyle"]}>
            <div className="lg:pb-20 pb-10 lg:pt-36 pt-10 px-4 lg:px-0">
                <div className="flex justify-between flex-col lg:flex-row">
                    <div className="3xl:max-w-[900px]  lg:max-w-[600px] ">
                        <h1 className="font-bold  3xl:text-7xl 3xl:leading-[5.5rem] lg:text-5xl lg:leading-[4.5rem] text-2xl leading-9 ">
                            {replacePlaceholders(post.title, {
                                category,
                            })}
                        </h1>
                        <p className="3xl:text-xl lg:text-base text-sm text-[#818181] mt-1 lg:mt-0 3xl:mt-1 mb-3 lg:mb-0">
                            Last Updated On : {getFormattedDate(post.updatedAt)}
                        </p>
                    </div>
                    <div>
                        <p className="3xl:text-3xl lg:text-2xl text-lg mb-3">
                            Share this post
                        </p>
                        <div className="flex gap-2 mt-2 lg:mt-0  lg:justify-center">
                            <motion.span
                                onClick={() => {
                                    window.open(
                                        `https://www.facebook.com/sharer/sharer.php?u=${getUrl(
                                            mainUrl,
                                        )}`,
                                        "",
                                        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600",
                                    );
                                    return false;
                                }}
                                style={{ borderRadius: "50% 50%" }}
                                className="cursor-pointer relative 3xl:w-[52px] 3xl:h-[52px] sm:w-[42px] sm:h-[42px] w-[32px] h-[32px]"
                                whileHover={{
                                    y: [0, -9],
                                }}
                            >
                                <FaceBookIcon />
                            </motion.span>
                            <motion.span
                                onClick={() => {
                                    window.open(
                                        `https://twitter.com/share?url=${getUrl(
                                            mainUrl,
                                        )}`,
                                        "",
                                        "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600",
                                    );
                                    return false;
                                }}
                                style={{ borderRadius: "50% 50%" }}
                                className="cursor-pointer relative 3xl:w-[52px] 3xl:h-[52px] sm:w-[42px] sm:h-[42px] w-[32px] h-[32px]"
                                whileHover={{
                                    y: [0, -9],
                                }}
                            >
                                <XIcon />
                            </motion.span>

                            <motion.span
                                onClick={async () => {
                                    try {
                                        await navigator.clipboard.writeText(
                                            window.location.href,
                                        );

                                        setShowCopySuccessMessage(true);
                                        setTimeout(() => {
                                            setShowCopySuccessMessage(false);
                                        }, 1000);
                                    } catch {
                                        return;
                                    }
                                }}
                                style={{ borderRadius: "50% 50%" }}
                                className="cursor-pointer relative 3xl:w-[52px] 3xl:h-[52px] sm:w-[42px] sm:h-[42px] w-[32px] h-[32px]"
                                whileHover={{
                                    y: [0, -9],
                                }}
                            >
                                <CopyLinkIcon />
                                <span
                                    className={`${style["toolTipText"]} ${
                                        showCopySuccessMessage
                                            ? "inline-block"
                                            : "hidden"
                                    }`}
                                >
                                    Copied to Clipboard
                                </span>
                            </motion.span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
